/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_DetailsInputs */

const en_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Details`)
};

const es_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de Envío`)
};

const fr_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails d'Expédition`)
};

const de_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versanddetails`)
};

const ja_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配送の詳細`)
};

const zh_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配送详情`)
};

const ar_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل الشحن`)
};

const id_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Pengiriman`)
};

const it_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli di Spedizione`)
};

const ru_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали Доставки`)
};

const pt_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes de Envio`)
};

const ko_shipping_details = /** @type {(inputs: Shipping_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배송 정보`)
};

/**
* | output |
* | --- |
* | "Shipping Details" |
*
* @param {Shipping_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_details = /** @type {((inputs?: Shipping_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_details(inputs)
	if (locale === "es") return es_shipping_details(inputs)
	if (locale === "fr") return fr_shipping_details(inputs)
	if (locale === "de") return de_shipping_details(inputs)
	if (locale === "ja") return ja_shipping_details(inputs)
	if (locale === "zh") return zh_shipping_details(inputs)
	if (locale === "ar") return ar_shipping_details(inputs)
	if (locale === "id") return id_shipping_details(inputs)
	if (locale === "it") return it_shipping_details(inputs)
	if (locale === "ru") return ru_shipping_details(inputs)
	if (locale === "pt") return pt_shipping_details(inputs)
	return ko_shipping_details(inputs)
});